import { useState } from 'react';

export const useLinkListMarkErrored = () => {
	const [erroredIndices, setErroredIndices] = useState<Set<number>>(new Set());
	const markErrored = (idx: number) => setErroredIndices((prev) => new Set(prev).add(idx));
	return { erroredIndices, markErrored };
};
